module.exports = __webpack_public_path__ + "img/video-01.74dd29f0.jpg";